import React, {useState} from 'react';
import {View, StyleSheet} from 'react-native';
import {useTimeout} from '../../hooks/useTimeout';
import {Props} from './model';
import {Loader} from '../loader';
import {useSelector} from 'react-redux';
import {isInternetReachableSelector} from '../../../redux/selectors/httpWrapper/netInfo';

const startAnimationAfterMs = 300;
const minAnimationDurationMs = 500;

const dataSetAttrs = {
  dataSet: {
    class: 'loadable-content',
  },
};
const styles = StyleSheet.create({
  container: {flex: 1},
  loaderWrapper: {
    marginVertical: 50,
    alignItems: 'center',
  },
});

const LoadableComponent: React.FC<Props> = ({
  loading,
  loaderSize = 100,
  children,
  style,
  wrapperStyle,
  ...restProps
}) => {
  const isInternetReachable = useSelector(isInternetReachableSelector());
  const [showLoader, setShowLoader] = useState<boolean | null>(null);

  useTimeout(() => {
    if (loading) {
      setShowLoader(true);
    }
  }, startAnimationAfterMs);
  useTimeout(() => {
    setShowLoader(false);
  }, startAnimationAfterMs + minAnimationDurationMs);

  return (
    <View style={[styles.container, style]} {...dataSetAttrs} {...restProps}>
      {isInternetReachable && (showLoader || (showLoader === false && loading)) ? (
        <View style={[styles.loaderWrapper, wrapperStyle]}>
          <Loader size={loaderSize} />
        </View>
      ) : null}
      {!loading && !showLoader ? children : null}
    </View>
  );
};

export default LoadableComponent;
